import { render, staticRenderFns } from "./BarcodeScan.vue?vue&type=template&id=2fb80bf6&scoped=true&"
import script from "./BarcodeScan.vue?vue&type=script&lang=js&"
export * from "./BarcodeScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb80bf6",
  null
  
)

export default component.exports